<template>
	<el-tag :type="jisuan.type">{{jisuan.text}}</el-tag>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			jisuan(){
				switch(this.status){
					case 0:return {type:"warning",text:"待审核"};
					case 1:return {type:"success",text:"已审核"};
					case 2:return {type:"",text:"已归档"};
					case 3:return {type:"danger",text:"已驳回"};
				}
			}
		},
		props:["status"],
		created() {
			
		}
	}
</script>

<style>
</style>
